import React from 'react'
import agent from '../../agent'
import { connect } from 'react-redux'
import { ADD_TO_CART, REDUCE_FROM_CART } from '../../constants/actionTypes'

const mapDispatchToProps = dispatch => ({
    onClick: (type, payload) =>
        dispatch({ type: type, payload })
})

const CartItemButton = props => {
    const action = () => {
        let type
        if (props.type && props.type.toLowerCase() === 'reduce') {
            type = REDUCE_FROM_CART
        } else {
            type = ADD_TO_CART
        }
        props.onClick(type, props.product)
    }

    return (
        <i className={props.type && props.type.toLowerCase() === 'reduce' ? 'icon ion-ios-remove-circle' : 'icon ion-ios-add-circle'}
            onClick={action}></i>
    )
}

export default connect(() => ({}), mapDispatchToProps)(CartItemButton)
